import { render, staticRenderFns } from "./MaterialCategoryList.vue?vue&type=template&id=b901267a&"
import script from "./MaterialCategoryList.vue?vue&type=script&lang=js&"
export * from "./MaterialCategoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports